module.exports = __webpack_public_path__ + "static/img/info1.22bedd98.jpg";